export default __webpack_public_path__ + "static/media/create-product.980d2d87.webp";